import { CALENDAR_TYPE } from '../../../../../../../../../config/calendar_type';
import { FREQUENCY } from '../../../../../../../../../config/frequency_type';
const convertFrequency = function (frequency) {
  /*     if (!Number.isInteger(frequency)) {
        throw Errors.PRECONDITION_FAILED([
            {
                key: `pad_prescription__convertfrequency__could_not_convert`,
                data: { frequency },
            },
        ]);
    } */

  const MINUTES_IN_HOUR = 60;
  const MINUTES_IN_DAY = MINUTES_IN_HOUR * 24; // 1440;
  const MINUTES_IN_WEEK = MINUTES_IN_DAY * 7; // 10080;
  const MINUTES_IN_MONTH = MINUTES_IN_DAY * 30; // 43200;

  //const { FREQUENCY } = frequencyTypeConsts;

  const frequencyDefault = frequency => {
    return {
      calendarType: CALENDAR_TYPE.EVERY,
      frequencyTypeId: FREQUENCY.MINUTE_ID,
      frequencyAmount: frequency
    };
  };

  if (frequency > 0 && frequency < MINUTES_IN_HOUR) {
    const frequencyAmount = frequency;

    return {
      calendarType: CALENDAR_TYPE.EVERY,
      frequencyTypeId: FREQUENCY.MINUTE_ID,
      frequencyAmount
    };
  } else if (frequency >= MINUTES_IN_HOUR && frequency < MINUTES_IN_DAY) {
    const frequencyAmount = frequency / 60;

    if (!Number.isInteger(frequencyAmount)) {
      return frequencyDefault(frequency);
    }

    return {
      calendarType: CALENDAR_TYPE.EVERY,
      frequencyTypeId: FREQUENCY.HOUR_ID,
      frequencyAmount
    };
  } else if (frequency >= MINUTES_IN_DAY && frequency < MINUTES_IN_WEEK) {
    const frequencyAmount = frequency / 60 / 24;

    if (!Number.isInteger(frequencyAmount)) {
      return frequencyDefault(frequency);
    }

    return {
      calendarType: CALENDAR_TYPE.EVERY,
      frequencyTypeId: FREQUENCY.DAY_ID,
      frequencyAmount
    };
  } else if (frequency >= MINUTES_IN_WEEK && frequency < MINUTES_IN_MONTH) {
    const frequencyAmount = frequency / 60 / 24 / 7;

    if (!Number.isInteger(frequencyAmount)) {
      return frequencyDefault(frequency);
    }

    return {
      calendarType: CALENDAR_TYPE.EVERY,
      frequencyTypeId: FREQUENCY.WEEK_ID,
      frequencyAmount
    };
  } else if (frequency >= MINUTES_IN_MONTH) {
    const frequencyInDays = frequency / 60 / 24;
    const frequencyInWeeks = frequency / 60 / 24 / 7;
    const frequencyInMonths = frequency / 60 / 24 / 30;

    if (Number.isInteger(frequencyInMonths)) {
      return {
        calendarType: CALENDAR_TYPE.EVERY,
        frequencyTypeId: FREQUENCY.MONTH_ID,
        frequencyAmount: frequencyInMonths
      };
    } else if (Number.isInteger(frequencyInWeeks)) {
      return {
        calendarType: CALENDAR_TYPE.EVERY,
        frequencyTypeId: FREQUENCY.WEEK_ID,
        frequencyAmount: frequencyInWeeks
      };
    } else if (Number.isInteger(frequencyInDays)) {
      return {
        calendarType: CALENDAR_TYPE.EVERY,
        frequencyTypeId: FREQUENCY.DAY_ID,
        frequencyAmount: frequencyInDays
      };
    } else {
      return frequencyDefault(frequency);
    }
  } else {
    return {
      calendarType: CALENDAR_TYPE.EVERY,
      frequencyTypeId: FREQUENCY.MINUTE_ID,
      frequencyAmount: frequency
    };
  }

  // const { EVERY, TIMES_PER /* , PER_SHIFT  */ } = padPrescriptionConsts.CALENDAR_TYPE;
  // const { WEEK_ID, /*  BIWEEK, */ MONTH_ID, DAY_ID, MINUTE, HOUR_ID } = frequencyTypeConsts.FREQUENCY;

  // const valueInMinutes = frequency;
  // const minutes = valueInMinutes;
  // const hours = valueInMinutes / 60;
  // const days = valueInMinutes / (24 * 60);
  // const weeks = valueInMinutes / (7 * 24 * 60);
  // const months = valueInMinutes / (30 * 24 * 60);

  // if (months && months >= 1) {
  //     // FREQUÊNCIA: A CADA MÊS
  //     return { calendarType: EVERY, frequencyTypeId: MONTH_ID, frequencyAmount: months };
  // }

  // if (weeks && weeks >= 1) {
  //     if (Number.isInteger(weeks)) {
  //         // FREQUÊNCIA: A CADA SEMANA
  //         return { calendarType: EVERY, frequencyTypeId: WEEK_ID, frequencyAmount: weeks };
  //     } else {
  //         // FREQUÊNCIA: VEZES POR MÊS
  //         let months = 4;
  //         months /= weeks;

  //         const newMonth = Math.round(months);

  //         return { calendarType: TIMES_PER, frequencyTypeId: MONTH_ID, frequencyAmount: newMonth };
  //     }
  // }

  // if (days && days >= 1) {
  //     if (Number.isInteger(days)) {
  //         // FREQUÊNCIA: A CADA DIA
  //         return { calendarType: EVERY, frequencyTypeId: DAY_ID, frequencyAmount: days };
  //     } else {
  //         // FREQUÊNCIA: VEZES POR SEMANA
  //         let weeks = 7;
  //         weeks /= days;

  //         const newWeeks = Math.round(weeks);

  //         return { calendarType: TIMES_PER, frequencyTypeId: WEEK_ID, frequencyAmount: newWeeks };
  //     }
  // }

  // if (hours && hours >= 1) {
  //     if (Number.isInteger(hours)) {
  //         // FREQUÊNCIA: A CADA HORA
  //         return { calendarType: EVERY, frequencyTypeId: HOUR_ID, frequencyAmount: hours };
  //     } else {
  //         // FREQUÊNCIA: VEZES POR DIA
  //         let day = 24;
  //         day /= hours;

  //         const newDay = Math.round(day);

  //         return { calendarType: TIMES_PER, frequencyTypeId: DAY_ID, frequencyAmount: newDay };
  //     }
  // }

  // if (minutes && minutes >= 1) {
  //     // FREQUÊNCIA: A CADA MINUTO
  //     return { calendarType: EVERY, frequencyTypeId: MINUTE, frequencyAmount: minutes };
  // }

  // throw Errors.PRECONDITION_FAILED([
  //     {
  //         key: `pad_prescription__convertfrequency__could_not_convert`,
  //         data: { frequency },
  //     },
  // ]);
};

export default convertFrequency;
